export const WEB_SOCIAL = {
  label: 'Standalone Website',
  value: 'web-social',
  channel: 'web',
  disabled: false,
  navigationLimit: 8,
  tabs: ['screens', 'profile-viewer', 'share'],
  freeformTemplates: [
    {
      label: 'Empty',
      description: 'Page with no initial content',
      template: 'FreeformPage',
      thumbnail: 'web-hero-page.png',
      preset: 'default',
      content: [],
    },
  ],
  defaultTemplate: {
    name: 'new-screen',
    title: `New Screen`,
    template: 'FreeformPage',
    preset: 'default',
    content: [],
  },
  unknownTemplate: 'web-hero-page.png',
  navigationAlignmentOptions: [
    { label: 'Left', value: 'left', default: true },
    { label: 'Center', value: 'center' },
    { label: 'Right', value: 'right' },
  ],
  navigationVisibilityOptions: [
    { label: 'Always visible', value: 'alwaysVisible' },
    { label: 'Always hidden', value: 'hidden', default: true },
    { label: 'Visible after scrolling', value: 'visibleOnScroll' },
  ],
  logoPositionOptions: [
    { label: 'Left', value: 'left', default: true },
    { label: 'Top', value: 'top' },
  ],
  authOptions: [
    { label: 'Always', value: 'always' },
    { label: 'Optional', value: 'optional' },
    { label: 'None', value: 'none' },
  ],
}
